import { useMemo } from 'react';

import { useFlags } from 'launchdarkly-react-client-sdk';

import createV5MessagesCalls from './messages-v5-adapter';
import apiClient from 'fetch-utils/api-client';

/**
 * Messages API adapter that allows swapping implementations (v3 vs v5)
 * from a single place, gated by LaunchDarkly.
 *
 * When the v5MessagesBackend flag is enabled, the adapter will route all
 * messages API calls to the v5 endpoints. Otherwise, it will use the v3 endpoints.
 */

export const useMessagesApi = () => {
  const flags = useFlags();
  const isV5Enabled = Boolean(flags.v5MessagesBackend);

  const v3Api = apiClient.messages;
  const v5Api = useMemo(() => createV5MessagesCalls(apiClient.client), []);

  const api = useMemo(
    () => (isV5Enabled ? v5Api : v3Api),
    [isV5Enabled, v3Api, v5Api]
  );

  return api;
};

export type MessagesApi = ReturnType<typeof useMessagesApi>;
